import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import { Icon } from '@captaincause/ui/Icon'
import { Markdown } from '@captaincause/ui/Markdown'
import { tm } from '@captaincause/ui/tm'
import { flattenFaq } from 'utils/strapi/flattenFaq'
import { Button } from 'components/Button'
import type { StrapiApiFaq, StrapiFaq } from 'types/strapi/faq'

export function FaqItem({ question, answer }: StrapiFaq) {
  const [isSelected, setIsSelected] = useState(false)

  if (!question || !answer) return null

  return (
    <button
      type="button"
      onClick={() => setIsSelected(!isSelected)}
      className="group flex w-full flex-col items-start space-y-4 rounded-lg border border-inside p-6 hover:bg-light-beige"
    >
      <div className="flex w-full items-center justify-between">
        <div className="text-2xl font-medium">{question}</div>
        <Icon
          icon="arrow-forward"
          size="big"
          className={tm(
            'ml-auto inline transition-transform duration-300 ease-out',
            isSelected && 'rotate-90',
          )}
        />
      </div>
      <Markdown className={tm('hidden w-full', isSelected && 'block')}>
        {answer}
      </Markdown>
    </button>
  )
}

interface FaqProps {
  faq: StrapiFaq[] | StrapiApiFaq
  withTitle?: boolean
}

export default function Faq({ faq: pFaq, withTitle = true }: FaqProps) {
  const { t } = useTranslation('faq.block')

  let faq: StrapiFaq[]
  if ('data' in pFaq) faq = flattenFaq(pFaq)
  else faq = pFaq

  if (!faq || faq.length === 0) return null

  return (
    <div className="mx-auto w-full max-w-[1400px] bg-white px-4 py-12 md:px-8 md:py-20">
      {withTitle ? (
        <div className="mb-8 flex flex-wrap items-center justify-between">
          <h2 className="mb-4 block text-center font-default text-2xl font-semibold leading-8 -tracking-[1.5px] md:order-[unset] md:text-[40px] md:leading-[48px]">
            {t('title')}
          </h2>
          <Button variant="secondary" href="/cadeau">
            {t('link.title')}
          </Button>
        </div>
      ) : null}

      <section className="mx-auto flex w-full flex-col gap-y-6">
        {faq.map(item => (
          <FaqItem key={item.id} {...item} />
        ))}
      </section>
    </div>
  )
}
